import { render, staticRenderFns } from "./productimgpopup.vue?vue&type=template&id=f18c3330"
import script from "./productimgpopup.vue?vue&type=script&lang=js"
export * from "./productimgpopup.vue?vue&type=script&lang=js"
import style0 from "./productimgpopup.vue?vue&type=style&index=0&id=f18c3330&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports